import { useNavigate } from "react-router-dom";

export default function InternalHeader({ title, action = null, backTo = null }) {
  const navigate = useNavigate();
  return (
    <header className="internal-header">
      <button
        type="button"
        aria-label="Volver"
        onClick={() => backTo ? navigate(backTo) : navigate(-1)}
      >
        ‹
      </button>
      <strong>{title}</strong>
      <div>{action}</div>
    </header>
  );
}
